import type { BariPreMedConsultPlanAppointmentData } from '@common/validation/customControls/bariPre/bariPreMedConsultPlanAppointment/v1/bariPreMedConsultPlanAppointmentSchemaV1';

export const initialData: BariPreMedConsultPlanAppointmentData = {
    toelichting: null,
};
